import { ExpertTag } from './ExpertTag'

export default ExpertTag
